import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';

// ----------------------------------------------------------------------
// Dev-only. For full-page takeover screens that render with NO chrome of
// their own — no dashboard sidebar/header (PrototypeShell), no auth-flow
// logo/card (AuthPrototypeShell). Use for states like offline, maintenance,
// or session-expired, where the real screen composes its own layout (e.g.
// the real CompactLayout, as src/views/error/not-found-view.tsx does).
// ----------------------------------------------------------------------

export function BarePrototypeShell() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Outlet />
    </Box>
  );
}
